import { useState, useEffect, useRef, type Dispatch, type SetStateAction } from "react";

import { internationalSubCategories } from "../Config";
import { useCategoriesStore } from "../stores/CategoriesStore";
import { useNavigate } from "react-router-dom";

export const InternationalCategorySelect = () => {
	let navigate = useNavigate();
	const triggerRef = useRef(null);
	const optionsRef = useRef(null);
	const { currentInternationalCategory } = useCategoriesStore((currentInternationalCategory) => currentInternationalCategory);
	const [currentSubCategory, setCurrentSubCategory] = useState({ name: "", url: "" });
	const windowPathname = typeof window !== "undefined" ? location.pathname : "";
	const currentInternationalCategoryUrl = currentInternationalCategory.replace(" ", "-")

	const initializeCurrentSubCategory = () => {
		const subCategory = internationalSubCategories.find((internationalSubCategory) => windowPathname.includes(internationalSubCategory.name.toLowerCase()));
		setCurrentSubCategory(subCategory ?? { name: "", url: "" });
	};

	const ChangeCurrentUrl = (currentUrl) => {
		console.log('currentUrl', currentUrl)
		setCurrentSubCategory(internationalSubCategories.find((internationalSubCategory) => `${currentInternationalCategoryUrl}${internationalSubCategory.name.toLowerCase() === "all" ? "" : `-${internationalSubCategory.url}`}-flowers` === currentUrl));
		navigate(`/${currentUrl}`);
	};

	useEffect(() => {
		const toggleSelectOptions = () => optionsRef.current.classList.toggle("active");

		const hideSelectOptions = () => optionsRef.current.classList.remove("active");

		if (triggerRef.current && optionsRef.current) {
			triggerRef.current.onclick = () => toggleSelectOptions();

			document.addEventListener("click", (event) => {
				!triggerRef.current.contains(event.target) && !optionsRef.current.contains(event.target) ? hideSelectOptions() : "";
			});
		}

		initializeCurrentSubCategory();
	}, [triggerRef, optionsRef]);

	return (
		<div className="field">
			<label htmlFor="category-sort">Occasion</label>

			<select
				id="international-category"
				name="international-category"
				value={`${currentInternationalCategoryUrl}${currentSubCategory.name.toLowerCase() === "all" ? "" : `-${currentSubCategory.url}`}-flowers`}
				onChange={(event) => ChangeCurrentUrl(event.target.value)}
			>	
				{internationalSubCategories?.map((internationalSubCategory, index) => (
					<option
						key={index}
						value={`${currentInternationalCategoryUrl}${internationalSubCategory.name.toLowerCase() === "all" ? "" : `-${internationalSubCategory.url}`}-flowers`}
					>
						{internationalSubCategory.name}
					</option>
				))}
			</select>
		</div>
	);
};

export default InternationalCategorySelect;
